let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3DpJm")).then(() => parcelRequire('6aD0e'));